<ng-template #contentHeaderTemplate>
  <div class="row">
    <div class="col-12 d-flex justify-content-end ">
      <button class="btn btn-primary" (click)="save()">
        {{ (entry?.id ? 'misc.save_btn' : 'misc.create_btn') | translate }}
      </button>
    </div>
  </div>
</ng-template>

<div class="row g-3">

  <div class="col-12 col-md-9 order-md-1">
    <form [formGroup]="form" (submit)="save()">
      <div class="card mb-3">
        <div class="card-header">
          {{ 'authenticated.time_tracking.entries.edit.header' | translate }}
        </div>
        <div class="card-body">

          <div class="row">

            <div class="col-12 col-lg-6 py-1">
              <app-multi-select-enum
                [enum]="TimeTrackingEntryTypeEnum"
                [formControl]="form.controls.type"
                [multi]="false"
                translateKey="timeTrackingEntryTypeEnum"
                label="{{'authenticated.time_tracking.entries.edit.form.type.label' | translate }}"
                [errorMessages]="{required: ('authenticated.time_tracking.entries.edit.form.type.validation_messages.required' | translate)}"
              ></app-multi-select-enum>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.break_time"
                label="{{'authenticated.time_tracking.entries.edit.form.break_time.label' | translate }}"
                [errorMessages]="{pattern: ('authenticated.time_tracking.entries.edit.form.break_time.validation_messages.pattern' | translate)}"
              ></app-form-group>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-date-time
                [timeMode]="TIME_MODE.SET_TIME"
                [formControl]="form.controls.start_at"
                label="{{'authenticated.time_tracking.entries.edit.form.start_at.label' | translate }}"
                [errorMessages]="{required: ('authenticated.time_tracking.entries.edit.form.start_at.validation_messages.required' | translate)}"
              ></app-date-time>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-date-time
                [timeMode]="TIME_MODE.SET_TIME"
                [formControl]="form.controls.end_at"
                label="{{'authenticated.time_tracking.entries.edit.form.end_at.label' | translate }}"
                [errorMessages]="{required: ('authenticated.time_tracking.entries.edit.form.end_at.validation_messages.required' | translate)}"
              ></app-date-time>
            </div>

          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="col-12 col-md-3 order-md-2">
    @if (entry) {
      <app-delete-card
        itemName="{{ 'authenticated.time_tracking.entries.delete.item' | translate }}"
        (deleteTriggered)="delete()"
      ></app-delete-card>
    }
  </div>

</div>
